import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable()
export class ApiPrefixInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (
      !req.url.includes("http:") &&
      !req.url.includes("https:") &&
      !req.url.includes("i18n") &&
      !req.url.includes("ws")
    ) {
      // console.log("Intercepted Request to Append Server URL", req.url);

      if (environment.production) {
        if (!environment.serverUrl) {
          console.log("Server URL not updated for production");
          environment.serverUrl = `${environment.baseApiUrl}${environment.apiProvider}${environment.apiVersion}`;
          console.log("Updated server URL", environment.serverUrl);
        }
      }
      req = req.clone({ url: environment.serverUrl + req.url });
    }

    return next.handle(req);
  }
}
